import { jsx as _jsx } from "react/jsx-runtime";
import { MainContext } from './context';
import { KeyboardShortcutsProvider } from './context/keyboard-shortcuts-context';
import { SearchProvider } from './context/search/search-context';
import { PublishQueueProvider } from './context/publish-queue-context';
/**
 * The single home for the app-wide providers, so the whole stack reads top to
 * bottom in one place. Ordered outer→inner; keyboard shortcuts and search wrap
 * every route (admin included). Router, theme, and Helmet stay at the app entry —
 * they're supplied by whoever mounts the library. The query client sits above, in
 * `Main`, so the hooks that build `mainContext` can read it. Lower-tier,
 * feature-scoped providers (e.g. the navbar chrome) stay with their feature.
 */
export const AppProviders = ({ mainContext, children }) => (_jsx(MainContext.Provider, { value: mainContext, children: _jsx(KeyboardShortcutsProvider, { children: _jsx(SearchProvider, { children: _jsx(PublishQueueProvider, { children: children }) }) }) }));
//# sourceMappingURL=app-providers.js.map